
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'
import Panel from 'vux/src/components/panel/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {get,post} from '../api'
export default {
name:'ProductMgr',
components: {
Tabbar,
TabbarItem,
Panel,
XHeader,
Group,
Tab,
TabItem,
Cell,
Toast
},
mounted(){
if(this.GLOBAL.currentUser==undefined){
this.$router.push({ path: '/' });
}
let parameter={POwner:this.GLOBAL.currentUser.BusinessGuid,PType:'NONE'};
if(this.tabIndex==0){
parameter.PType='CP';
}
else if(this.tabIndex==1){
parameter.PType='MP';
}
post('/productinfo/query', parameter).then(response => {

this.productInfo.splice(0, this.productInfo.length);
this.productDatas.splice(0, this.productDatas.length);
if(response.code==1){
let index=0;
response.data.forEach(element => {
let picUrl=this.GLOBAL.mpUrl;
if(element.PType=='MP'){
picUrl=this.GLOBAL.mpUrl;
}
else if(element.PType=='CP'){
picUrl=this.GLOBAL.cpUrl;
}

this.productInfo.push({
src: picUrl,
title: element.title,
desc: element.desc,
url: '/ProductDetail?id='+index+'&tag=E'
});
index++;
});
this.productDatas=response.data;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
this.productInfo.splice(0, this.productInfo.length);
this.productDatas.splice(0, this.productDatas.length);
console.log(error);
});
},
methods: {
onItemClick () {
console.log('click tab', this.tabIndex);
let parameter={POwner:this.GLOBAL.currentUser.BusinessGuid,PType:'NONE'};
if(this.tabIndex==0){
parameter.PType='CP';
}
else if(this.tabIndex==1){
parameter.PType='MP';
}
post('/productinfo/query', parameter).then(response => {

this.productInfo.splice(0, this.productInfo.length);
this.productDatas.splice(0, this.productDatas.length);
if(response.code==1){
let index=0;
response.data.forEach(element => {
let picUrl=this.GLOBAL.mpUrl;
if(element.PType=='MP'){
picUrl=this.GLOBAL.mpUrl;
}
else if(element.PType=='CP'){
picUrl=this.GLOBAL.cpUrl;
}

this.productInfo.push({
src: picUrl,
title: element.title,
desc: element.desc,
url: '/ProductDetail?id='+index+'&tag=E'
});
index++;
});
this.productDatas=response.data;
}
else if(response.code==0){
this.showError=true;
}
else if(response.code==1001){
this.WarnInfo=response.message;
this.showWarn=true;
}
}).catch(error => {
this.productInfo.splice(0, this.productInfo.length);
this.productDatas.splice(0, this.productDatas.length);
console.log(error);
});
},
onImgError (item, $event) {
console.log(item, $event)
},
addInfos(){
if(this.GLOBAL.currentUser.Status==-1){
this.showWarn=true;
this.WarnInfo="账号正在审核中,请耐心等待...";
return;
}
else if(this.GLOBAL.currentUser.Status==0){
this.showWarn=true;
this.WarnInfo="账号审核不通过,请重新提交材料...";
return;
}
else if(this.GLOBAL.currentUser.Status==2){
this.showWarn=true;
this.WarnInfo="账号会员已过期,请充值续费...";
return;
}
this.$router.push({ path: '/ProductDetail?tag=A&index='+this.tabIndex });
},
onClickItem(item){
this.GLOBAL.currentObjs=this.productDatas;
}
},
data () {
return {
type: '5',
productInfo: [],
productDatas:[],
footer: {
title: "",
url: ''
},
tabIndex:0,
showSuccess:false,
showWarn:false,
showError:false,
SuccessInfo:'查询成功!',
WarnInfo:'',
ErrorInfo:'系统异常,联系管理员!',
}
}
}



// WEBPACK FOOTER //
// ./src/components/BusinessModules/ProductMgr.vue